<template>
  <div class="response-results">
    <v-row class="my-2">
      <h2>
        登録・利用状況
      </h2>
    </v-row>
    <v-row>
      <v-card
        flat
        rounded="0"
        width="100%"
        color="white">
        <v-row class="pa-4">
          <v-col
            md="2"
            align-self="center"
          >
            <h3>累計登録数</h3>
          </v-col>
          <v-col
            v-if="allRegistrationCount !== null"
            md="10"
            class="text-right text-h4 font-weight-bold"
          >
            {{ formatter.formatNumberWithComma(allRegistrationCount) }}
          </v-col>
        </v-row>
      </v-card>
    </v-row>
    <v-row>
      <v-card
        flat
        rounded="0"
        width="100%"
        color="white"
        class="mt-4 pb-3">
        <v-card-title
          class="d-flex font-weight-bold align-center"
          style="overflow: visible">
          <month-picker
            v-model:selectedDate="selectedDate"
            @on-month-changed="saveSelectedDate"
            style="font-size: 1rem"
          />
          <div class="ml-2">の登録・利用数</div>

          <div class="w-100 d-flex justify-end">
            <v-btn
              variant="outlined"
              prepend-icon="custom:download"
              height="40"
              border="md"
              :color="color.mainColor()"
              @click="downloadCSV"
              class="font-weight-bold border-current"
            >
              CSVダウンロード
            </v-btn>
          </div>
        </v-card-title>

        <v-row class="px-4">
          <v-col md="4">
            <v-card
              flat
              rounded="0"
              :color="color.mainBgColor()">
              <v-card-title
                class="text-body-2 font-weight-bold text-glance-base">
                <v-icon
                icon="custom:addPerson"
                :color="color.mainColor()" />
                会員登録数
              </v-card-title>
              <v-card-text
                v-if="targetMonthRegistrationCount !== null"
                class="text-h4 font-weight-bold text-glance-base"
              >
                {{ formatter.formatNumberWithComma(targetMonthRegistrationCount) }}
              </v-card-text>
            </v-card>

            <v-card
              flat
              rounded="0"
              class="mt-2"
              :color="color.syounikaBgColor()">
              <v-card-title
                class="text-body-1 font-weight-bold">
                <div class="d-flex">
                  <div class="text-syounika-primary">小児科</div>
                  <div
                    v-if="targetMonthSyounikaRegistrationCount !== null"
                    class="w-100 text-right align-self-end text-glance-base"
                  >
                    {{ targetMonthSyounikaRegistrationCount }}
                  </div>
                </div>
              </v-card-title>
            </v-card>
            <v-card
              flat
              rounded="0"
              :color="color.obstetricsBgColor()">
              <v-card-title
                class="text-body-1 font-weight-bold">
                <div class="d-flex">
                  <div class="text-obstetrics-primary">産婦人科</div>
                  <div
                    v-if="targetMonthObstetricsRegistrationCount !== null"
                    class="w-100 text-right align-self-end text-glance-base"
                  >
                    {{ targetMonthObstetricsRegistrationCount }}
                  </div>
                </div>
              </v-card-title>
            </v-card>
          </v-col>
          <template v-if="countOfUsages">
            <v-col md="4">
              <v-card
                flat
                rounded="0"
                :color="color.mainBgColor()">
                <v-card-title
                  class="text-body-2 font-weight-bold text-glance-base">
                  <v-icon
                  icon="custom:board"
                  :color="color.mainColor()" />
                  オンライン相談利用数
                </v-card-title>
                <v-card-text
                  class="text-h4 font-weight-bold text-glance-base"
                >
                {{ formatter.formatNumberWithComma(countOfUsages.syounika.total + countOfUsages.obstetrics.total) }}
                </v-card-text>
              </v-card>
              <v-card
                flat
                rounded="0"
                class="mt-2"
                :color="color.syounikaBgColor()">
                <v-card-title
                  class="text-body-1 font-weight-bold">
                  <div class="d-flex">
                    <div class="text-syounika-primary">小児科</div>
                    <div class="w-100 text-right align-self-end text-glance-base">{{ countOfUsages.syounika.total }}</div>
                  </div>
                </v-card-title>
                <v-card-item
                  height="30"
                  width="100"
                  class="font-size-075-rem bg-light-gray font-weight-bold py-1 text-glance-base">
                  <div class="d-flex">
                    <div class="text-no-wrap">いつでも</div>
                    <div class="w-100 text-right align-self-end">{{ countOfUsages.syounika.anytimeConsultation }}</div>
                  </div>
                </v-card-item>
                <v-card-item
                  height="30"
                  width="100"
                  class="font-size-075-rem bg-light-gray font-weight-bold py-1 text-glance-base">
                  <div class="d-flex">
                    <div class="text-no-wrap">夜間</div>
                    <div class="w-100 text-right align-self-end">{{ countOfUsages.syounika.reservation }}</div>
                  </div>
                </v-card-item>
              </v-card>
              <v-card
                flat
                rounded="0"
                style="margin-top: 1px;"
                :color="color.obstetricsBgColor()">
                <v-card-title
                  class="text-body-1 font-weight-bold">
                  <div class="d-flex">
                    <div class="text-obstetrics-primary">産婦人科</div>
                    <div class="w-100 text-right align-self-end text-glance-base">{{ countOfUsages.obstetrics.total }}</div>
                  </div>
                </v-card-title>
                <v-card-item
                  height="30"
                  width="100"
                  class="font-size-075-rem bg-light-gray font-weight-bold py-1 text-glance-base">
                  <div class="d-flex">
                    <div class="text-no-wrap">いつでも</div>
                    <div class="w-100 text-right align-self-end">{{ countOfUsages.obstetrics.anytimeConsultation }}</div>
                  </div>
                </v-card-item>
                <v-card-item
                  height="30"
                  width="100"
                  class="font-size-075-rem bg-light-gray font-weight-bold py-1 text-glance-base">
                  <div class="d-flex">
                    <div class="text-no-wrap">夜間</div>
                    <div class="w-100 text-right align-self-end">{{ countOfUsages.obstetrics.reservation }}</div>
                  </div>
                </v-card-item>
                <v-card-item
                  v-if="corporation && corporation.midwifeAvailable"
                  height="30"
                  width="100"
                  class="font-size-075-rem bg-light-gray font-weight-bold py-1 text-glance-base">
                  <div class="d-flex">
                    <div class="text-no-wrap">日中助産師</div>
                    <div class="w-100 text-right align-self-end">{{ countOfUsages.obstetrics.daytimeAdvice }}</div>
                  </div>
                </v-card-item>
              </v-card>
              <v-card
                flat
                rounded="0">
                <v-card-actions
                  class="link-actions px-0">
                  <v-list
                    class="text-body-2">
                    <v-list-item
                      prepend-icon="mdi-chevron-right"
                      title="主訴一覧"
                      height="20"
                      link
                      slim
                      class="pa-0"
                      :ripple="{class: 'text-transparent'}"
                      :to="{ path: role.isSales() ? '/complaints_edit' : '/complaints'}"
                    >
                    </v-list-item>
                    <v-list-item
                      prepend-icon="mdi-chevron-right"
                      title="アンケートフリー回答一覧"
                      height="20"
                      link
                      slim
                      class="pa-0"
                      :ripple="{class: 'text-transparent'}"
                      :to="{ path: role.isSales() ? '/questionnaires_edit' : '/questionnaires'}"
                    >
                    </v-list-item>
                    <v-list-item
                      prepend-icon="mdi-chevron-right"
                      title="アンケート集計"
                      height="20"
                      link
                      slim
                      class="pa-0"
                      :ripple="{class: 'text-transparent'}"
                      :to="{ path: '/questionnaires_analytics'}"
                    >
                    </v-list-item>
                  </v-list>
                </v-card-actions>
              </v-card>
            </v-col>
          </template>
          <template v-if="corporation && corporation.casesearchAvailable && casesearchViewLogsCount">
            <v-col md="4">
              <v-card
                flat
                rounded="0"
                :color="color.mainBgColor()">
                <v-card-title
                  class="text-body-2 font-weight-bold text-glance-base">
                  <v-icon
                  icon="custom:search"
                  :color="color.mainColor()" />
                  みんなの相談検索事例閲覧数
                </v-card-title>
                <v-card-text
                  class="text-h4 font-weight-bold text-glance-base"
                >
                {{ formatter.formatNumberWithComma(casesearchViewLogsCount.total) }}
                </v-card-text>
              </v-card>
              <v-card
                flat
                rounded="0"
                class="mt-2"
                :color="color.syounikaBgColor()">
                <v-card-title
                  class="text-body-1 font-weight-bold">
                  <div class="d-flex">
                    <div class="text-syounika-primary">小児科</div>
                    <div class="w-100 text-right align-self-end text-glance-base">{{ casesearchViewLogsCount.syounika }}</div>
                  </div>
                </v-card-title>
              </v-card>
              <v-card
                flat
                rounded="0"
                :color="color.obstetricsBgColor()">
                <v-card-title
                  class="text-body-1 font-weight-bold">
                  <div class="d-flex">
                    <div class="text-obstetrics-primary">産婦人科</div>
                    <div class="w-100 text-right align-self-end text-glance-base">{{ casesearchViewLogsCount.obstetrics }}</div>
                  </div>
                </v-card-title>
              </v-card>
              <v-card
                flat
                rounded="0">
                <v-card-actions
                  class="link-actions px-0">
                  <v-list
                    class="text-body-2">
                    <v-list-item
                      prepend-icon="mdi-chevron-right"
                      title="検索ワードランキング"
                      height="20"
                      link
                      slim
                      class="pa-0"
                      :ripple="{class: 'text-transparent'}"
                      :to="{ path: '/casesearch_query_logs'}"
                    >
                    </v-list-item>
                  </v-list>
                </v-card-actions>
              </v-card>
            </v-col>
          </template>
        </v-row>
      </v-card>
    </v-row>
    <v-row>
      <v-col class="pl-0 d-flex justify-space-between">
        <div class="font-size-075-rem text-color-light-gray w-100">
          ※月次報告の送付以降の数値を確定数値としてご利用ください。月内の利用数値は変動する場合があります。
        </div>
        <div class="d-flex justify-end">
            <v-btn
              variant="flat"
              border="0"
              append-icon="mdi-chevron-right"
              height="40"
              :color="color.mainColor()"
              :to="{ path: '/yearly_summary' }"
              class="text-white font-weight-bold"
            >
              登録・利用数推移
            </v-btn>
          </div>
      </v-col>
    </v-row>
  </div>
</template>

<script lang="ts">
import { defineComponent, computed, onMounted} from "vue"
import { useStore } from "../../stores/index"
import monthPicker from "./MonthPicker.vue"
import { themeColor } from "../../service/theme_color"
import { textFormatter } from "../../service/text_formatter"
import { roles } from "../../service/roles"

export default defineComponent({
  name: "ResponseResultsPart",
  components: {
    monthPicker
  },

  setup() {
    // vuex
    const store = useStore()
    // settings
    const color = themeColor()
    const formatter = textFormatter()
    const role = roles()
    // data
    const currentUser = computed(() => store.getters.currentUser)
    const selectedDate = computed(() => new Date(store.getters.selectedHomeDate))
    const allRegistrationCount = computed(() => store.getters.allRegistrationCount)
    const targetMonthRegistrationCount = computed(() => store.getters.targetMonthRegistrationCount)
    const targetMonthSyounikaRegistrationCount = computed(() => store.getters.targetMonthSyounikaRegistrationCount)
    const targetMonthObstetricsRegistrationCount = computed(() => store.getters.targetMonthObstetricsRegistrationCount)
    const casesearchViewLogsCount = computed(() => store.getters.casesearchViewLogsCount)
    const countOfUsages = computed(() => store.getters.countOfUsages)
    const corporation = computed(() => store.getters.corporation)

    const saveSelectedDate = async (selectedValue: Date) => {
      await store.dispatch("commitSelectedHomeDate", selectedValue)
    }

    const downloadCSV = async () => {
      await store.dispatch("downloadResponseResults")
    }

    onMounted(() => {
      store.dispatch("commitSelectedHomeDate", selectedDate.value)
    })

    return {
      currentUser,
      selectedDate,
      allRegistrationCount,
      targetMonthRegistrationCount,
      targetMonthSyounikaRegistrationCount,
      targetMonthObstetricsRegistrationCount,
      casesearchViewLogsCount,
      saveSelectedDate,
      downloadCSV,
      countOfUsages,
      corporation,
      color,
      formatter,
      role
    }
  }

})
</script>

<style lang="scss">
  .response-results{
    .link-actions {
      .v-list{
        padding-inline: 0px;
      }
      .v-list-item:hover {
        color: #3ACAC9;
        .v-list-item__overlay {
          opacity: 0 !important;
        }
      }

      .v-list-item.v-list-item--density-default.v-list-item--one-line {
        min-height: 20px;
      }
      .v-list-item {
        .v-list-item-title {
          font-size: 0.875rem;
        }
        .v-list-item__prepend {
          color: #3ACAC9;
          font-size: 0.875rem;
          /* アイコンと文字列の間隔を調整 */
          .v-list-item__spacer{
            width: 5px !important;
          }
        }
      }
    }
  }
</style>
